/* eslint-disable arrow-body-style */
import { MenuItem } from '@mui/material';
import React from 'react';
import Iconify from 'src/components/Iconify';
import { TableMoreMenu } from 'src/components/table';

// The section header's Edit / Delete menu. The section is addressed by its
// index in the course the screen shows; the hook never keeps a copy of it.
export const useCourseSummery = (
  onEditSection: VoidFunction,
  onDeleteSection: VoidFunction,
  setExpanded: React.Dispatch<React.SetStateAction<string | false>>,
  disabled = false
) => {
  const [openMenu, setOpenMenuActions] = React.useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = (event?: any) => {
    event?.stopPropagation();
    setOpenMenuActions(null);
  };

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  const getMenuItem = () => {
    return (
      <TableMoreMenu
        open={openMenu}
        onOpen={handleOpenMenu}
        onClose={handleCloseMenu}
        actions={
          <>
            <MenuItem
              disabled={disabled}
              onClick={(e?: any) => {
                onEditSection();
                handleCloseMenu(e);
              }}
            >
              <Iconify icon={'eva:edit-fill'} />
              Edit
            </MenuItem>
            <MenuItem
              disabled={disabled}
              onClick={(e?: any) => {
                onDeleteSection();
                handleCloseMenu(e);
              }}
              sx={{ color: 'error.main' }}
            >
              <Iconify icon={'eva:trash-2-outline'} />
              Delete
            </MenuItem>
          </>
        }
      />
    );
  };
  return {
    handleChange,
    getMenuItem,
  };
};
